import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex align-start" },
    [
      _c(VCheckbox, {
        staticClass: "mt-0 pt-0 mr-2",
        attrs: { color: "primary", "hide-details": "" },
        model: {
          value: _setup.isAgree,
          callback: function ($$v) {
            _setup.isAgree = $$v
          },
          expression: "isAgree",
        },
      }),
      _vm._v(" "),
      _vm.isLpu
        ? _c("div", { staticClass: "text-body-2 text--text" }, [
            _vm._v(
              "\n    " + _vm._s(_setup.t("Подаю", _setup.options)) + "\n    "
            ),
            _c(
              "a",
              {
                staticClass: "text-decoration-none primary--text d-inline",
                attrs: {
                  target: "_blank",
                  rel: "noopener noreferrer",
                  href: _vm.registrationAgreementLink,
                },
              },
              [_vm._v(_vm._s(_setup.t("заявление", _setup.options)))]
            ),
            _vm._v(
              "\n    " +
                _vm._s(
                  _setup.t(
                    "на подключение юрлица и обработку персональных данных",
                    _setup.options
                  )
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isDoctor
        ? _c("div", { staticClass: "text-body-2 text--text" }, [
            _vm._v(
              "\n    " + _vm._s(_setup.t("Даю", _setup.options)) + "\n    "
            ),
            _c(
              "a",
              {
                staticClass: "text-decoration-none primary--text d-inline",
                attrs: {
                  target: "_blank",
                  rel: "noopener noreferrer",
                  href: _vm.registrationAgreementLink,
                },
              },
              [_vm._v(_vm._s(_setup.t("согласие", _setup.options)))]
            ),
            _vm._v(
              "\n    " +
                _vm._s(
                  _setup.t("на обработку персональных данных", _setup.options)
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }